var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},[_vm._t("default",null,{"brief":_vm.brief,"isLoading":_vm.isLoading,"errors":_vm.errors,"errorMessage":_vm.errorMessage,"task":_vm.task,"content":_vm.content,"goToContent":_vm.handleGoToContent})],2)}
var staticRenderFns = []

export { render, staticRenderFns }